import { render, staticRenderFns } from "./registerEntryModelks_nwd.vue?vue&type=template&id=5a31a910&scoped=true"
import script from "./registerEntryModelks_nwd.vue?vue&type=script&lang=js"
export * from "./registerEntryModelks_nwd.vue?vue&type=script&lang=js"
import style0 from "./registerEntryModelks_nwd.vue?vue&type=style&index=0&id=5a31a910&prod&scoped=true&lang=css"
import style1 from "./registerEntryModelks_nwd.vue?vue&type=style&index=1&id=5a31a910&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a31a910",
  null
  
)

export default component.exports